import * as Sentry from '@sentry/browser'

const logError = err => {
  if (process.env.NODE_ENV === 'development') console.error(err)

  if (process.env.NODE_ENV === 'production') Sentry.captureException(err)
}

export default logError
